export interface WorldParameters {
  atmosphere: {
    temperature: number
    humidity: number
    pressure: number
    co2Level: number
    oxygenLevel: number
    radiation?: number
    toxicity?: number
  }
  geology: {
    tectonicActivity: number
    volcanicActivity: number
    seismicActivity: number
    landElevation: number
  }
  hydrosphere: {
    waterLevel: number
    oceanTemperature: number
    iceCoverage: number
    riverFlow: number
  }
  biosphere: {
    plantCoverage: number
    animalDiversity: number
    microbialActivity: number
    biomass: number
    photosynthesisRate?: number
    biodiversity?: number
  }
  civilization: {
    population: number
    technologyLevel: number
    pollution: number
    resourceConsumption: number
  }
}

export interface GameState {
  worldId: string
  worldName: string
  worldAge: number
  parameters: WorldParameters
  activeEvents: string[]
  history: Array<{
    age: number
    event: string
    description: string
  }>
  achievements: string[]
  isAlive: boolean
}

export enum PlayerAction {
  MAKE_RAIN = 'make_rain',
  TRIGGER_VOLCANO = 'trigger_volcano',
  TRIGGER_EARTHQUAKE = 'trigger_earthquake',
  BOOST_LIFE = 'boost_life',
  MELT_ICE = 'melt_ice',
  RAISE_LAND = 'raise_land',
  CREATE_STORM = 'create_storm',
  ADVANCE_TECH = 'advance_tech',
  PURIFY_ENVIRONMENT = 'purify_environment',
  GENERATE_RESOURCES = 'generate_resources'
}

export interface ActionInfo {
  id: PlayerAction
  name: string
  description: string
  energyCost: number
  cooldown: number
  learningPoints: string[]
  icon?: string
}